<template>
	<div>
		<div class="card my-3">
			<div class="card-header">
				<p class="card-titile mb-0 text-muted font-weight-bold">Mural informativo</p>
			</div>
		</div>

		<div class="list-group" v-if="publicacionesDisp.length>0">
			<div :class="{'list-group-item':true, 'bg-light':publicacion.ESTATUS==0}" v-for="publicacion in publicacionesDisp">
				<div class="d-flex w-100 justify-content-between mb-2">
					<div>
						<small class="text-muted"><timeago :datetime="publicacion.FECHA_CREACION" :auto-update="30"></timeago></small>
						<span v-if="publicacion.ESTATUS==0">
							<small class="font-weight-bold">(publicación desactivada)</small>
						</span>
					</div>
				</div>
				<p v-html="urlify(publicacion.DESCRIPCION_PUBLICACION)" :class="{'publicacion-text':true, 'text-muted':publicacion.ESTATUS==0}"></p>
				<div class="row justify-content-center">
					<div class="col-md-6">
						<img :src="publicacion.IMG_URL" class="img-fluid" v-if="publicacion.IMG_URL">
					</div>
				</div>
			</div>
		</div>
		<div v-else>
			<div class="card rounded-fill overflow-hidden">
				<div class="card-body text-center">
					<h5 class="text-muted">No tiene publicaciones disponibles</h5>
				</div>
			</div>
		</div>
		<infinite-loading @infinite="infiniteHandler" ref="InfiniteLoading"></infinite-loading>
	</div>
</template>
<script>
	export default {
		data(){
			return {
				publicaciones: [],
				loading: false
			}
		},

		methods: {
			urlify(text){
				var urlRegex = /(((https?:\/\/)|(www\.))[^\s]+)/g;
				//var urlRegex = /(https?:\/\/[^\s]+)/g;
				return text.replace(urlRegex, function(url,b,c) {
					var url2 = (c == 'www.') ?  'http://' +url : url;
					return '<a href="' +url2+ '" target="_blank">' + url + '</a>';
					//return '<a href="' + url + '" target="_blank">' + url + '</a>';
				})
			},

			infiniteHandler($state){
	        	axios.get('/api/publicaciones/disponibles', {
    				url: this.publicaciones.next_page_url
    			})
    			.then(response => {
    				if (this.publicaciones.current_page+1 == response.data.current_page) {
		                this.publicaciones = {
		                    current_page: response.data.current_page,
		                    data: this.publicaciones.data.concat(response.data.data),
		                    first_page_url: response.data.first_page_url,
		                    from: response.data.from,
		                    last_page: response.data.last_page,
		                    last_page_url: response.data.last_page_url,
		                    next_page_url: response.data.next_page_url,
		                    path: response.data.path,
		                    per_page: response.data.per_page,
		                    prev_page_url: response.data.prev_page_url,
		                    to: response.data.to,
		                    total: response.data.total
		                }
		            }else{
		                this.publicaciones = response.data
		            }

    				if(response.data.length > 0 && this.publicaciones.next_page_url != null){
    					$state.loaded()
    				}else{
    					$state.complete()
    				}
    			})
	        },
	    },
	    computed: {
	    	publicacionesDisp(){
	    		return this.publicaciones.data || []
	    	},
	    },
	}
</script>